module.exports = __webpack_public_path__ + "static/media/undraw_questions.d4257691.svg";